import { config } from './constants'

const awsconfig = {
  Auth: {
    Cognito: {
      userPoolId: config.USER_POOL_ID,
      userPoolClientId: config.APP_CLIENT_ID
    }
  }
}

export default awsconfig
